import { Component, ComponentFactoryResolver, ComponentRef, inject, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { interval, Subscription } from 'rxjs';
import { NotificationFacade } from '@core/facades/notification.facade';
import { ConfirmDialogComponent } from '@shared/ui/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  // private worker: Worker;
  private authService = inject(AuthService);
  private router = inject(Router);
  private subs: Subscription[] = [];
  private inActiveTimer: number = 0;
  private logoutSub?: Subscription;
  private popUpService = inject(NotificationFacade);

  
  
  constructor() {
    // this.worker = new Worker('token-refresh-worker.js');
    // Listen for visibility changes
    this.trackRefreshToken();
    this.trackLoginInactivity();
    window.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.inActiveTimer = 0;
        this.logoutSub?.unsubscribe();
      } else {
        this.trackLoginInactivity();
      }
    });
  }

  ngOnInit(): void {}

  // ... other methods

  trackLoginInactivity(): void {
    // Check if the user is on the auth
    if (this.router.url.indexOf('/auth/') > -1) {
      // Do nothing if the user is on the auth page
    }
    else {
      this.logoutSub = interval(60000) // 60 seconds
        .subscribe(() => {
          try{
            this.inActiveTimer += 60; //add 60 seconds
          //Logout after 5min of inactivity
          if (this.inActiveTimer >= (60 * 5) && this.router.url !== '/auth/login' && document.visibilityState === 'hidden') {
            this.authService.storeReturnUrl();
            this.router.navigateByUrl('/auth/login');
          } else {
            this.inActiveTimer = 0
          }
          } catch(e){
            console.log("Inactivity tracker error",e)
          }
        });
    }
  }
  trackRefreshToken(): void {
    const sub = interval(10000) // 10 seconds
      .subscribe(() => {
        if (this.router.url.indexOf('/auth/') === -1 && document.visibilityState === 'visible') {

          const decoded = this.authService.getDecodedAccessToken();
          if (decoded?.exp) {
            const timer = decoded?.exp - Date.now() / 1000;
            if (timer <= 45) {
              const sub = this.authService.getRefreshToken().subscribe({
                error: (error) => {
                  const errorMessage =
                    error?.error?.message || error?.message || '';
                  if (
                    !errorMessage.includes('Token still has long validity time')
                  ) {
                    this.authService.storeReturnUrl();
                    this.router.navigateByUrl('/auth/login');
                  } else {
                    // Token is still valid, just log it
                    console.log('Token refresh skipped - token still valid');
                  }
                },
              });
              this.subs.push(sub);
            }
          }
        }
      });
    this.subs.push(sub);
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
    this.logoutSub?.unsubscribe();
    this.popUpService.closeAllPopups();
  }
}